import React from "react";
import Home from "../../../components/Home/Home";

const Teaches = () => {
  return (
    <div className="ml-8 mr-16">
      <Home />
    </div>
  );
};

export default Teaches;
